const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

function stub() {
  if (window.fbq) return;
  const n = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  window.fbq = n;
  window._fbq = n;
}

export function initPixel() {
  if (!PIXEL_ID || window.__pixelInit) return;
  window.__pixelInit = true;
  stub();
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  const load = () => {
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  };
  if ("requestIdleCallback" in window) window.requestIdleCallback(load, { timeout: 3000 });
  else setTimeout(load, 1500);
}

export function track(event, params) {
  if (window.fbq) window.fbq("track", event, params);
}
